module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $, undefined) {
	
	'use strict';

	var Promise = fox.RSVP.Promise;

	fox.registerWidget('TransactionsView', {
		configure: function () {
			this.registerOptions('', {
				autoRender: true,
				widgets: {
					empty: {
						widget: 'EmptyPlaceholder',
						'embed.container': '#transactions-grid-container',
					},
					loader: {
						widget: 'PromisePreloader',
						'embed.container': '#transactions-grid-container'
					},
					dataProvider: {
						widget: 'Datalayer',
						method: 'dashboard.getTransactionsByUser',
						limit: 20
					},
					transactionList: {
						widget: 'Grid',
						externalLoad: true,
						autoRender: true,
						'embed.container': '#transactions-grid-container',
						template: 'transactions_view_container',
						dl: '@parent #dataProvider',
						list: {
							'tpl.row': 'sitepage_transactions_list_row',
							'embed.container': '#transaction-list'
						},
						pager: {
							widget: 'ContentPager',
							rppShow: true
						}
					},
					periodSelector: {
						widget: 'PeriodSelector',
						allowSameDates: true
					}
				},
				handleDom: {
					sort: {
						event: 'click',
						target: '.s-arrow',
						targetWidget: '#transactionList',
						callback: 'sortColumn'
					},
					filterByUser: {
						event: 'keyup',
						target: '#filter-by-user',
						eventChecker: function (e) {
							return e.keyCode === 13;
						}.bind(this),
						callback: 'filterByUser'
					},
					filterByUserOnIcon: {
						event: 'click',
						target: '.icon-mc_other_search',
						callback: 'filterByUser'
					},
					resetFilter: {
						target: '.icon-mc_other_clearfilter',
						callback: function (btn) {
							return this.filterByUser($(btn).parent().find('input').val('').get(0));
						}
					}
				},
				handleWom: {
					applyRange: {
						event: 'applyRange',
						widget: '#periodSelector',
						callback: function () {
							return this.getTransactions();
						}.bind(this)
					},
					discardRange: {
						event: 'discardRange',
						widget: '#periodSelector',
						callback: function () {
							this.showMessage(
								'Please try to choose another time range in a date picker.',
								'error'
							);
						}.bind(this)
					}
				}
			});

			this.registerOptions('#dataProvider #api', {
				'hooks.onPrepare': function (params) {
					var link = params.params;
					this.setOption('sendTimezone', false);
					fox.each(link.transitParameters, function (value, prop) {
						link[prop] = value;
					});

					delete link.transitParameters;
				},
				'handleWom.onError': {
					event: ['error', 'failure'],
					widget: '@this',
					callback: this.getTransactionsResponseError.bind(this)
				}
			});

			this.registerOptions('#empty #content', {
				template: 'empty_transaction_list'
			});
		
			this.callParent('configure', arguments);
		},

		running: function () {
			this.search = false;
			this.getTransactions();
			this.notices = fox.wom.selectFirst('~#throughNotifications');
		
			this.callParent('running', arguments);
		},

		getTransactions: function (params) {
			params = params || {};

			var loader = this.rwom1('#loader');
			var periodSelector = this.rwom1('#periodSelector');
			var provider = this.rwom1('#dataProvider');
			var empty = this.rwom1('#empty');
			var promise;

			if (periodSelector.isEmbedded()) {
				promise = Promise.resolve(periodSelector.getParamsForApi());
			} else {
				promise = this.wait(periodSelector, 'childrenAddedToDom').then(function () {
					return periodSelector.getParamsForApi();
				});
			}

			return promise.then(function (period) {
				return fox.merge(params, period);
			}).then(function (params) {
				fox.each(params, function (param, name) {
					provider.setTransitParameter(name, param);
				});
				
				return loader.show(provider.load().then(function () {
					return provider.getCount() === 0;
				}.bind(this)));
			}.bind(this)).then(function (isEmpty) {
				var $searchBlock = $(this.dom1('#search'));

				if (!isEmpty){
					this.rwom1('#transactionList').setTemplateOptions(provider._meta);
				} else {
					if(this.search === false){
						if($searchBlock){$searchBlock.hide();}
					} else {
						if($searchBlock){$searchBlock.show();}
					}
				}

				return empty.showIfEmpty(empty.wait(this, 'addedToDom').then(function () {
					
					return isEmpty;
				}));
			}.bind(this));
		},

		filterByUser: function (el, alias) {
			if (alias === 'filterByUserOnIcon') {
				el = el.previousElementSibling;
			}

			var name = fox.trim(el.value);
			var $wrapper = $(el.parentNode);

			if (name) {
				$wrapper.addClass('have-filter');
				this.search = true;
			} else {
				$wrapper.removeClass('have-filter');
				this.search = false;
			}

			this.setTemplateOptions('nameFilter', name);
			this.wait('addedToDom').then(function () {
				el = this.dom1('#' + $(el).attr('id'));
				el.setSelectionRange(name.length, name.length);
				el.focus();
			}.bind(this));

			
			this.getTransactions({clientName: name});
		},

		sortColumn: function (el) {
			var $el = $(el);
			var provider = this.rwom1('#dataProvider');
			var fieldRefs = this.getOption('fieldRefs') || {};
			var field;
			var attrName;

			if ($el.hasClass('active')) return;
			
			var direction = $el.data('direction');
			attrName = field = $el.parent().data('field');

			if (field in fieldRefs) {
				field = fieldRefs[field];
			}

			$el.parent().parent().parent().find('.sort-control .active').removeClass('active');
			$el.addClass('active');

			this.wait('#transactionList', 'addedToDom').then(function (resp) {
				$(resp.performer.dom1('[data-field="' + attrName + '"] [data-direction="' + direction + '"]'))
					.addClass('active');
			});

			if (this.getOption('frontendSort')) {
				provider.setCollection(this.sortCollection(field, direction));
				return this.rwom1('#transactionList').render();
			}

			provider
				.clearSorting()
				.addSorting(field, direction, 'default');

			return this.getTransactions();
		},

		getTransactionsResponse: function (res) {
			res = res.params;

			var $dummy = $(this.dom1('#dummy'));
						
			if (res.answer && res.answer.response && !fox.isEmpty(res.answer.response.collection)) {
				this.transactionsData = fox.toArray(res.answer.response.collection);
				$dummy.hide();
			} else {
				$dummy.show();
			}
		},

		getTransactionsResponseError: function() {
			var loader = this.rwom1('#loader');

			if (loader.isEmbedded()) loader.removeFromDom();

			this.showMessage(
				'There are too many transactions for a specified period. Please try to choose smaller time range in a date picker.',
				'error'
			);
		},

		showMessage: function (message, type) {
			this.notices.pushNotification({
				noticeType: type,
				noticeAlias: 'TransactionsViewMessage',
				noticeMessage: message,
				delayClose: 5000,
			});
		},

		sortCollection: function (field, direction) {
			var c = this.rwom1('#dataProvider').getCollection();
			 
			return c.sort(function (v1, v2) {
				if (v1[field] === v2[field]) return 0;
				if (v1[field] < v2[field]) return direction === 'desc' ? 1 : -1;
				if (v1[field] > v2[field]) return direction === 'desc' ? -1 : 1;
			});
		}

	}, 'Widget');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/sitepage/transactions/transactionsView.js
// module id = 358
// module chunks = 2